<template>
  <div class="news-headlines-detail">
         <!-- <HeaderTop></HeaderTop> -->
        <!-- <Header :page="5"></Header> -->
        <div class="news-detail-wrapper pddding main flex-between">
            <div class="news_detail_left">
                <div class="content-box">
                    <div class="title-box">
                        <!-- <h3 class="f18">{{article.title}}</h3> -->
                        <!-- <p class="source f12">{{article.source}}</p> -->
                        <div class="summary f12 flex-align-between">
                            <!-- <div class="box">
                                <span>{{article.createTime}}</span>
                            </div> -->
                          
                        </div>
                    </div>
                    <div class="content" v-html="article.content">
                        
                    </div>
                  
                   
                </div>
            </div>
           
        </div>
         <footer-view></footer-view>

  </div>
</template>

<script>
export default {
    data() {
        return {
        article:{},
        currentPage: 1,
        
        }
    },
     watch: {
        '$route': function(to,from){
            document.body.scrollTop = 0
            document.documentElement.scrollTop = 0
        }
    },
    methods: {
        async GetContent(id){
            let params = {
                id : id,
            }
            let resData = await Api.Home.getDetail(params)
            this.article = resData.data;

         },
        

        async getNewsList() {
            let params = {
                clazz:14,
                pageNum:1,
                pageSize:1,
            }
            let resData = await Api.Home.getNewsList(params);
            if(resData.rows.length>0){
                this.GetContent(resData.rows[0].dId)
            }
        },

       
    },
    mounted(){
        this.getNewsList()
    },

}
</script>

<style lang="less" scoped>
    @import "./less/news_headlines_detail.less";
    .pddding {
        padding-top:30px;
    }
</style>